import {Box, Typography} from '@material-ui/core'
import {CheckCircle, Error as ErrorIcon} from '@mui/icons-material'
import React from 'react'
import {useTranslation} from 'react-i18next'

interface OrderCardHeaderProps {
  isSuccess: boolean
  index: number
  formattedDate: string
  formattedTime: string
  statusIconClassName: string
}

export const OrderCardHeader: React.FC<OrderCardHeaderProps> = ({
  isSuccess,
  index,
  formattedDate,
  formattedTime,
  statusIconClassName
}) => {
  const {t} = useTranslation()

  return (
    <Box display="flex" alignItems="center" justifyContent="space-between">
      <Box display="flex" alignItems="center">
        {isSuccess ? (
          <CheckCircle className={statusIconClassName} style={{color: '#0F9E53'}} />
        ) : (
          <ErrorIcon className={statusIconClassName} style={{color: '#E53E3E'}} />
        )}
        <Typography variant="h4" color="textPrimary">
          {t('orderIntake.splitLoad.orderNumber', {number: index + 1})}
        </Typography>
      </Box>
      <Typography variant="body2" color="secondary">
        {formattedDate}, {formattedTime}
      </Typography>
    </Box>
  )
}
